"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.Lock = void 0;
class Lock {
    constructor() {
        this._mutex = Promise.resolve();
    }
    lock() {
        // tslint:disable-next-line no-empty
        let begin = (_unlock => { });
        this._mutex = this._mutex.then(() => {
            return new Promise(begin);
        });
        return new Promise(res => {
            begin = res;
        });
    }
    async dispatch(fn) {
        const unlock = await this.lock();
        try {
            return await Promise.resolve(fn());
        }
        finally {
            unlock();
        }
    }
}
exports.Lock = Lock;
//# sourceMappingURL=lock.js.map